/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowMoveRight = createReactComponent("outline", "arrow-move-right", "IconArrowMoveRight", [["path", { "d": "M11 12h10", "key": "svg-0" }], ["path", { "d": "M18 9l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M7 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z", "key": "svg-2" }]]);

export { IconArrowMoveRight as default };
//# sourceMappingURL=IconArrowMoveRight.mjs.map
